import { Component, input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { ClRadioButton } from '@corelabs/angular/ui';
import { ErrorComponent } from '../error/error.component';
import { FormOption } from '../form-option.type';

@Component({
    selector: 'app-form-radio-button',
    templateUrl: './form-radio-button.component.html',
    styleUrls: ['./form-radio-button.component.css'],
    imports: [ReactiveFormsModule, ClRadioButton, ErrorComponent],
})
export class FormRadioButtonComponent<T> {
    readonly control = input.required<FormControl<T>>();
    readonly label = input.required<string>();
    readonly options = input.required<FormOption<T>[]>();
    readonly inputId = input.required<string>();
    readonly name = input.required<string>();
    readonly direction = input<'horizontal' | 'vertical'>('vertical');
}
